import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/services/apiClient'
import type { AdapterAuditEventListResponse } from '@/types/toolFramework'

export function useAuditEvents(filters?: {
  personaId?: string
  conversationId?: string
  adapterId?: string
  success?: boolean
  cursor?: string
  limit?: number
}) {
  return useQuery({
    queryKey: ['auditEvents', filters],
    queryFn: () => {
      const params = new URLSearchParams()
      if (filters?.personaId) params.set('persona_id', filters.personaId)
      if (filters?.conversationId) params.set('conversation_id', filters.conversationId)
      if (filters?.adapterId) params.set('adapter_id', filters.adapterId)
      if (filters?.success !== undefined) params.set('success', String(filters.success))
      if (filters?.cursor) params.set('cursor', filters.cursor)
      if (filters?.limit !== undefined) params.set('limit', String(filters.limit))
      const qs = params.toString()
      return apiClient.get<AdapterAuditEventListResponse>(
        `/api/adapters/audit-events${qs ? `?${qs}` : ''}`,
      )
    },
  })
}
